import { Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import { Works } from "./pages/Works";
import { Notes } from "./pages/Notes";
import {InputTutorial} from './pages/InputTutorial'

export const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/works" element={<Works />} />
      <Route path="/journal" element={<Notes />} />
      <Route path="/tutorial" element={<InputTutorial />} />
    </Routes>
  );
};
